"use client";
import { useEffect } from "react";

const ResourcePreloader: React.FC = () => {
	useEffect(() => {
		// 只在客户端运行
		if (typeof window === "undefined") return;

		// 预加载关键图片
		const preloadImages = () => {
			const criticalImages = [
				"/image/banner/bannerbg.jpg",
				"/image/home/logo.png",
				"/image/default-image.webp",
			];

			criticalImages.forEach((src) => {
				const link = document.createElement("link");
				link.rel = "preload";
				link.as = "image";
				link.href = src;
				document.head.appendChild(link);
			});
		};

		// 预加载关键字体
		const preloadFonts = () => {
			const fonts = ["/fonts/Poppins-Light.otf"];

			fonts.forEach((font) => {
				const link = document.createElement("link");
				link.rel = "preload";
				link.as = "font";
				link.type = "font/otf";
				link.href = font;
				link.crossOrigin = "anonymous";
				document.head.appendChild(link);
			});
		};

		// 预加载关键CSS
		const preloadCSS = () => {
			const cssFiles = ["/antd.min.css"];

			cssFiles.forEach((css) => {
				const link = document.createElement("link");
				link.rel = "preload";
				link.as = "style";
				link.href = css;
				document.head.appendChild(link);
			});
		};

		// 预加载关键JS库
		const preloadScripts = () => {
			const scripts = [
				// 可以添加需要预加载的第三方脚本
			];

			scripts.forEach((script) => {
				const link = document.createElement("link");
				link.rel = "preload";
				link.as = "script";
				link.href = script;
				document.head.appendChild(link);
			});
		};

		// DNS预解析
		const dnsPrefetch = () => {
			const domains = ["//fonts.googleapis.com", "//fonts.gstatic.com"];

			domains.forEach((domain) => {
				const link = document.createElement("link");
				link.rel = "dns-prefetch";
				link.href = domain;
				document.head.appendChild(link);
			});
		};

		// 执行预加载
		preloadImages();
		preloadFonts();
		preloadCSS();
		preloadScripts();
		dnsPrefetch();

		// 预加载下一页可能需要的组件
		const preloadNextPageComponents = () => {
			setTimeout(() => {
				// 预加载可能需要的组件
				import("@/components/Home2/ProductCategories");
				import("@/components/Home2/WhyChooseUs");
				import("@/components/Blogs/BlogCard");
			}, 3000); // 3秒后开始预加载
		};

		preloadNextPageComponents();
	}, []);

	// 这个组件不渲染任何内容
	return null;
};

export default ResourcePreloader;
